import React, {useMemo} from 'react';
import {ErrorMessage} from "@hooks/validate/types";
import Stack from '@mui/material/Stack';
import SelectSearch from "@ui/select/selectSearch/SelectSearch";
import {
    usePlannedResourceSingleVoyageQuery
} from "@containers/singleVoyage/containers/plannedResources/queryHooks/usePlannedResourceSingleVoyageQuery";
import {useTranslation} from "react-i18next";
import {getErrorProps} from "@helpers/error";
import {sx} from "./sx";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

interface IProps {
    deviceId: string
    onChangeDeviceId: (value: string) => void
    driverId: string
    onChangeDriverId: (value: string) => void,
    error?: boolean,
    errorMessage?: ErrorMessage,
    plannedStart?: string
    plannedEnd?: string
    accountId: string | number
}

const SelectPlannedResourcesSingleVoyage = ({
                                                deviceId,
                                                onChangeDeviceId,
                                                driverId,
                                                onChangeDriverId,
                                                error,
                                                errorMessage,
                                                plannedStart,
                                                plannedEnd,
                                                accountId,
                                            }: IProps) => {

    const {
        data,
        isLoading
    } = usePlannedResourceSingleVoyageQuery({
        params: {
            accountId,
            plannedEnd,
            plannedStart
        }
    })

    const {t} = useTranslation()

    const dataSelect = useMemo(() => {
        return {
            devices: data?.devices?.map((item) => {
                return {
                    value: item.id?.toString(),
                    label: item.licensePlate
                }
            }),
            drivers: data?.drivers?.map((item) => {
                return {
                    value: item.id?.toString(),
                    label: item.name
                }
            })
        }
    }, [data])
    return (
        <Stack
            gap={1}
            sx={sx.root}
        >
            <Stack
                gap={'13px'}
                direction={'row'}
                sx={sx.inner}
                alignItems={'center'}
            >
                <SelectSearch
                    {...getErrorProps({errorMessage, error, key: 'deviceId'})}
                    isLoading={isLoading}
                    value={deviceId}
                    onChange={onChangeDeviceId}
                    data={dataSelect.devices}
                    label={t('singleVoyage.device')}
                    width={'100%'}
                />

                <DirectionsCarIcon
                    sx={sx.icon}
                />
            </Stack>

            <Stack
                gap={'13px'}
                direction={'row'}
                sx={sx.inner}
                alignItems={'center'}
            >
                <SelectSearch
                    {...getErrorProps({errorMessage, error, key: 'driverId'})}
                    isLoading={isLoading}
                    value={driverId}
                    onChange={onChangeDriverId}
                    data={dataSelect.drivers}
                    label={t('singleVoyage.driver')}
                    width={'100%'}
                />
                <PermIdentityIcon
                    fontSize={'medium'}
                    sx={sx.icon}
                />
            </Stack>


        </Stack>
    );
};

export default SelectPlannedResourcesSingleVoyage;